

    <ui-designer [fullscreen]="maximized" #designer>
      <ui-designer-v-box>
        <ui-designer-header>

          <nav class="d-flex flex-row align-items-center justify-content-between">

            <div class="d-flex align-items-center">
              <span class="icon cluster-icon"></span>
              <strong style="text-transform: uppercase">{{ workflow.name }}</strong>
              <span>&nbsp; ({{visibilityTypeText}})</span>
            </div>

            <div class="d-flex align-items-center">

              <button class="btn icon panel-left-icon" [class.activated]="elementsPanelVisible"
                      (click)="toggleElementsPanel()">&nbsp;
              </button>
              <button class="btn icon panel-right-icon" [class.activated]="propertiesPanelVisible"
                      (click)="togglePropertiesPanel()">&nbsp;
              </button>

              <div style="margin-left: 1rem;">
                <label>Zoom: </label>
                <select [(ngModel)]="zoom">
                  <option value="0.25">25%</option>
                  <option value=".5">50%</option>
                  <option value="0.75">75%</option>
                  <option value="1">100%</option>
                  <option value="1.5">150%</option>
                  <option value="2">200%</option>
                  <option value="4">400%</option>
                  <option value="8">800%</option>
                </select>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <button class="btn icon"
                      [ngClass]="{'resize-small-icon': designer.fullscreen, 'resize-full-icon': !designer.fullscreen }"
                      (click)="designer.toggleFullScreen()">&nbsp;
              </button>
              <button class="btn icon floppy-disk-icon" (click)="onDesignerSave()">&nbsp;</button>
              &nbsp;
              <button class="btn icon remove-icon" (click)="closed.emit()">&nbsp;</button>
            </div>

          </nav>

        </ui-designer-header>

        <ui-designer-h-box>
          <ui-designer-panel *ngIf="elementsPanelVisible" [bordered]="true" [width]="'16rem'">

            <ul class="nav nav-tabs primary-tabs" role="tablist" style="padding-top: 0.75rem; background-color: #fff;">
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': contextView === libraryContextView}"
                   href="javascript:;" (click)="changeContextView(libraryContextView)" role="tab">Library</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': contextView === testContextView}"
                   href="javascript:;" (click)="changeContextView(testContextView)" role="tab">Test</a>
              </li>
            </ul>

            <section>
              <ng-template [ngIf]="contextView === libraryContextView">
                <wf-vertex-library (clicked)="onLibraryElementClick($event)"></wf-vertex-library>
              </ng-template>

              <ng-template [ngIf]="contextView === testContextView">
                <wf-designer-test [workflow]="workflow"></wf-designer-test>
              </ng-template>
            </section>

          </ui-designer-panel>

          <ui-designer-panel [bordered]="false" [flex]="1">
            <wf-graph [workflow]="workflow" [zoom]="zoom" #graph
                      (vertexSelected)="onGraphVertexSelected($event)"
                      (multipleVerticesSelected)="onGraphMultipleVerticesSelected($event)"
                      (edgeAdded)="onGraphEdgeAdded($event)"
                      (vertexMoved)="onGraphVertexMoved($event)"></wf-graph>

            <div *ngIf="verticesSelected && verticesSelected.length > 0" class="floating-actions">
              <span style="vertical-align: sub;"><strong>{{verticesSelected.length}}</strong> selected.</span>
              <span style="float: right">
                <button class="btn btn-sm btn-danger" (click)="onSelectedRemoved()">Remove</button>
                <button class="btn btn-sm btn-warning" (click)="onSelectedCloned()">Clone</button>
              </span>
            </div>

          </ui-designer-panel>

          <ui-designer-panel *ngIf="propertiesPanelVisible" [bordered]="true" [width]="'16rem'">
            <section class="separate">
              <wf-designer-vertex-properties [vertex]="selectedVertex"></wf-designer-vertex-properties>
            </section>
          </ui-designer-panel>

        </ui-designer-h-box>

      </ui-designer-v-box>
    </ui-designer>

  


// WEBPACK FOOTER //
// ./src/library/designer/workflow-designer.component.ts.WorkflowDesignerComponent.html